





























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import { GetStudyReport } from "@/request/common";
import * as echarts from "echarts";
import "echarts-wordcloud";
@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends Vue {
  private data: any = {
    学习概况: {},
    常错知识点: {
      data: [],
      name: [],
    },
    模拟测试统计: {
      data: [],
      name: [],
    },
  };
  private gaikuangData: any = {};
  private tongjiData: any = {};
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }

  private get user() {
    return this.$store.state.user;
  }
  private drawGaikuang() {
    const num1: any = this.data["学习概况"]["已完成"] * 100;
    const num2: any = 100 - num1;
    this.gaikuangData = {
      title: {
        text: "" + num1.toFixed(1) + "%" + "\n" + "\n" + "已完成",
        x: "center",
        y: "center",
        textStyle: {
          fontWeight: "bold",
          color: "#333",
          fontSize: 18,
        },
      },
      color: ["#7DC075", "#ddd"],
      tooltip: {
        show: false,
        formatter: "{a} <br/>{b} : {c} ({d}%)",
      },
      legend: {
        show: false,
        itemGap: 12,
        data: ["已完成", "总题量"],
      },
      toolbox: {
        show: false,
        feature: {
          mark: {
            show: true,
          },
          dataView: {
            show: true,
            readOnly: false,
          },
          restore: {
            show: true,
          },
          saveAsImage: {
            show: true,
          },
        },
      },
      series: [
        {
          name: "Line 1",
          type: "pie",
          clockWise: false,
          radius: [60, 80],
          itemStyle: {
            normal: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
            },
          },
          hoverAnimation: false,

          data: [num1, num2],
        },
      ],
    };
  }
  private drawTongji() {
    this.tongjiData = {
      color: ["#2878ff"],
      tooltip: {
        trigger: "axis",
      },
      grid: {
        top: "30",
        left: "10",
        right: "10",
        bottom: "10",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: this.data["模拟测试统计"]["name"],
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          data: this.data["模拟测试统计"]["data"],
          type: "line",
          smooth: true,
        },
      ],
    };
  }
  private drawWordCloud() {
    var myChart: any = echarts.init(
      document.getElementById("wordCloud") as any
    );
    const option: any = {
      tooltip: {
        trigger: "item",
      },
      series: [
        {
          type: "wordCloud",

          // 要绘制云的形状,默认是 circle，可选的参数有 cardioid 、 diamond 、 triangle-forward 、 triangle 、 star
          shape: "circle",

          // 保持maskImage的纵横比或1:1的形状
          // 从echarts-wordcloud@2.1.0开始支持该选项
          keepAspect: false,

          // 左/上/宽/高/右/下用于字云的定位
          // 默认放置在中心，大小为75% x 80%。
          left: "center",
          top: "center",
          width: "70%",
          height: "80%",
          right: null,
          bottom: null,

          // 数据中的值将映射到的文本大小范围。
          // 默认值为最小12px，最大60px。
          sizeRange: [12, 60],

          // 文字旋转范围和步进程度。文本将通过rotationStep 45在[- 90,90]范围内随机旋转
          rotationRange: [-90, 90],
          rotationStep: 45,

          // 网格大小(以像素为单位)，用于标记画布的可用性
          // 网格大小越大，单词之间的间隔就越大
          gridSize: 8,

          // 设置为true允许文字部分地绘制在画布之外。
          // 允许画比画布大的字
          // 从echarts-wordcloud@2.1.0开始支持该选项
          drawOutOfBound: false,

          // 如果字体太大，无法显示文本，是否缩小文本。如果设置为false，则文本将不被渲染。如果设置为true，文本将被缩小。
          shrinkToFit: true,

          // 是否执行布局动画。
          //当单词较多时禁用会导致UI阻塞。
          layoutAnimation: true,

          // 全局文本样式
          textStyle: {
            fontFamily: "sans-serif",
            fontWeight: "bold",
            // Color可以是回调函数或颜色字符串
            normal: {
              color: function () {
                return `rgb(${[
                  Math.round(Math.random() * 200 + 55),
                  Math.round(Math.random() * 200 + 55),
                  Math.round(Math.random() * 200 + 55),
                ].join(",")})`;
              },
            },
          },
          emphasis: {
            focus: "self",
            textStyle: {
              textShadowBlur: 10,
              textShadowColor: "#333",
            },
          },
          data: this.data["常错知识点"]["data"],
        },
      ],
    };
    myChart.setOption(option);
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      user_id: this.user.user_id,
    };
    GetStudyReport(this, params, loading)
      .then((res: any) => {
        this.data = res;
        this.drawGaikuang();
        this.drawTongji();
        this.drawWordCloud();
        loading.close();
      })
      .catch(() => {
        loading.close();
      });
  }
  private mounted() {
    this.getData();
  }
}
